import { motion } from "framer-motion";
import { Receipt, PiggyBank, BarChart3, Clock } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface TrustPoint {
  text: string;
  icon: LucideIcon;
}

export const HumanFactorSection = () => {
  const trustPoints: TrustPoint[] = [
    {
      text: "You don't know how much you're actually keeping.",
      icon: Receipt,
    },
    {
      text: "You're losing money in places you can't see.",
      icon: PiggyBank,
    },
    {
      text: "No system tracking your numbers. Every decision is instinct.",
      icon: BarChart3,
    },
    {
      text: "You don't have time to figure any of this out.",
      icon: Clock,
    },
  ];

  return (
    <section className="py-16 px-6 bg-midnight">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
            Stop guessing. <span className="text-vault-green">Start knowing.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {trustPoints.map((point, index) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08, duration: 0.5 }}
                className="bg-white/5 border border-white/10 rounded-xl p-5 flex flex-row items-center gap-4"
              >
                <div className="w-10 h-10 shrink-0 rounded-lg bg-white/10 border border-white/15 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-white/70" strokeWidth={1.5} />
                </div>
                <p className="text-white/90 text-sm leading-relaxed font-medium text-left">
                  {point.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
